import * as React from 'react'

export default function HeadersWithContent({ obj }) {
    return (
        <>
            <div className="">
                <h5 className="heading-style-h5 text-color-primary text-left-mobile">
                    {obj.h2_1}
                </h5>
                <h2 className="heading-style-h2">
                    {obj.h1}
                </h2>
                <h2 className="heading-style-h2-no-margin text-color-primary">
                    {obj.h2}
                </h2>
                <p className="text-align-left paragraph24 margin-top margin-medium">
                    {obj.h3}
                </p>
            </div>
        </>
    )
}